module.exports = __webpack_public_path__ + "img/travelling.d6d9e8d6.svg";